const mutations = {
  'SET_BUSINESSES_MONTHLY_STATES_TASK' (state, { businessesMonthlyStatesTask, skipTimestamp = false }) {
    state.businessesMonthlyStatesTask = businessesMonthlyStatesTask;
    
    if (!skipTimestamp) {
      state.lastLocalUpdate = Date.now();
    }
  },
  
  'SET_BUSINESSES_MONTHLY_STATES_TASK_FROM_WEBSOCKET' (state, { businessesMonthlyStatesTask }) {
    const timeSinceLastUpdate = state.lastLocalUpdate ? Date.now() - state.lastLocalUpdate : Infinity;
    
    if (state.pendingUpdates === 0 && timeSinceLastUpdate > 2000) {
      state.businessesMonthlyStatesTask = businessesMonthlyStatesTask;
    } else {
      console.log('⏸️  Ignorando actualización de websocket para tasks (hay cambios locales recientes)');
    }
  },
  
  'INCREMENT_PENDING_UPDATES_TASK' (state) {
    state.pendingUpdates++;
  },
  
  'DECREMENT_PENDING_UPDATES_TASK' (state) {
    if (state.pendingUpdates > 0) {
      state.pendingUpdates--;
    }
  }
}

export default mutations